import { combineReducers } from 'redux';
import { APIReducer } from 'store/apiReducer';
import { CONTEXT_CONTACTER_PREFECTURE } from '../../constants/apiUrls.constants';

const contact = combineReducers({
    nousContacter: APIReducer.bind(null, CONTEXT_CONTACTER_PREFECTURE),
});

export default contact;
